module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LI-aca645f7011a276ff444728254122483.png";